(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Luna-Stickers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();
})();
